import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, getInlineLoader, remove255 } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLOSING_BALANCE,
	STR_COMMISSIONS_REPORT,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_CREATE_REPORT,
	STR_DESCRIPTON,
	STR_FLOAT,
	STR_INVALID_AGENT_TILLS,
	STR_INVALID_AMOUNT,
	STR_INVALID_DATE,
	STR_INVALID_PHONE,
	STR_INVALID_REPORT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_LINK_SUPERVISOR,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_OPENING_BALANCE,
	STR_OPTIONAL,
	STR_PAYABLE,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PHOTO_EVIDENCE,
	STR_RECEIVABLE,
	STR_RECENT_REQUESTS,
	STR_REPORT_DATE,
	STR_REPORT_FOR,
	STR_REPORT_TYPE,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SERVICE_PROVIDER,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_SUPERVISOR_PHONE,
	STR_TILL_NUMBER,
	STR_TOTAL_2,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";

export default function View(props) {

	const appContext = useContext(AppContext);

	const currentDateTime = new Date();
	currentDateTime.setHours(currentDateTime.getHours() + 3);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [supervisorPhone, setSupervisorPhone] = useState(Number(remove255(appContext.currentUserData.supervisorPhone)));
	
	
	const [opSuccessful, setOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}

	

	async function submit() {
		if(supervisorPhone && String(supervisorPhone).trim().length > 0) {
			setLoading(true);
			await callApi('link-supervisor', { supervisorPhone: `255${Number(supervisorPhone)}` }).then((response) => {
				if(response.status === 1) {
					appContext.getCurrentUserData();
					setOpSuccessful(true);
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_INVALID_PHONE[appContext.language]);
		}
	}


	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	

	if (ready) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingBottom: "calc(var(--topBarHeight) + 40px)",
					}}
					className="mNoScrollBar"
				>
					<div className="container">
	
						<div className="row">
	
							<div className="col-md-12">
								<h6
									className="mSectionTitle"
								>
									{STR_LINK_SUPERVISOR[appContext.language]}
								</h6>
							</div>

							{
								(opSuccessful) ?
								<div 
									className="col-md-12"
								>
									<OpSuccessWidget/>
								</div>
								:
								<div 
									className="col-md-12"
								>
									
									<div className="mt-3 mb-3">
										<div
											className="input-group"
										>
											<span
												className="input-group-text font-semi-bold text-secondary"
												style={{
													fontSize: "16px"
												}}
											>
												+255
											</span>
											<input
												className="form-control"
												onChange={(e) => setSupervisorPhone(_prev => {
													if (Number(e.target.value)) {
														return Number(e.target.value);
													} else if (String(e.target.value).trim().length === 0) {
														return "";
													} else {
														return _prev;
													}
												})}
												value={supervisorPhone}
												maxLength={10}
												placeholder="XXX XXX XXX"
												type="text"
												style={{
													fontSize: "16px"
												}}
											/>
										</div>
										<div className="form-text mb-3 mt-3">
											{STR_SUPERVISOR_PHONE[appContext.language]}
										</div>
									</div>

									<div className="mt-5 mb-3">
										<button
											className="btn btn-block btn-rounded btn-padded btn-primary"
											onClick={submit}
										>
											{STR_SUBMIT[appContext.language]}
										</button>
									</div>

								</div>
							}
	
						</div>
	
						
	
					</div>
	
	
				</div>
			)
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}